module.exports = __webpack_public_path__ + "static/media/icon-website.6e52a136.svg";